// extracted by mini-css-extract-plugin
export var signinContainer = "SignInButton-module--signin-container--xSNAT";
export var blue = "SignInButton-module--blue--1llc_";
export var green = "SignInButton-module--green--1DyH4";